import React, { Component } from 'react';
import { connect } from 'react-redux';
import NavBar from '../../components/NavBar.jsx';
import { GECKO_CONSTS, GeckoCardForm, GeckoToastService } from '../../ui';
import GeckoLocation from 'services/gecko-location';
import GeckoRequest from 'services/gecko-request';
import GeckoPermissions from 'services/gecko-permissions';
import { renderError } from 'services/gecko-error';
import { capitalise } from '../../utilities/capitaliseString.js';

class Invite extends Component {
  state = {
    values: {
      first_name: '',
      last_name: '',
      email: '',
      group_id: '',
    },
  };

  inviteAgent(e) {
    const first_name = this.state.values.first_name;
    const last_name = this.state.values.last_name;
    const email = this.state.values.email;
    const group_id = this.state.values.group_id;
    let toast = new GeckoToastService();
    this.setState({ resolving: true });
    GeckoRequest.post('/user/invite', {
      first_name,
      last_name,
      email,
      group_id,
    })
      .then(() => {
        GeckoLocation.goTo('../agents');
        toast.success(`Invite sent to ${first_name} ${last_name}`);
      })
      .catch(renderError);
  }

  fields = [
    {
      key: 'first_name',
      label: 'First Name',
    },
    {
      key: 'last_name',
      label: 'Last Name',
    },
    {
      key: 'email',
      label: 'Email',
    },
    {
      key: 'group_id',
      label: 'Group',
      type: 'select',
      options: this.props.groups.map((group) => {
        const [start, ...rest] = group.type;
        return {
          label: `${start.toUpperCase()}${rest.join('')}`,
          value: group.id,
        };
      }),
    },
  ];

  inviteFields() {
    let inviteFields = [
      {
        label: 'First Name:',
        key: 'first_name',
      },
      {
        label: 'Last Name:',
        key: 'last_name',
      },
      {
        label: 'Email:',
        key: 'email',
      },
    ];
    let options = [];
    if (GeckoPermissions.memberOf('supervisor')) {
      this.props.groups.map((group) => {
        if (group.type !== 'admin') {
          options.push({
            label: `${capitalise(group.type)}`,
            value: group.id,
          });
        }
        return group;
      });
      if (options.length) {
        inviteFields.push({
          label: 'Agent Type:',
          key: 'group_id',
          type: GECKO_CONSTS.FIELD_TYPE_SELECT,
          options: options,
          description: (
            <span>
              For more information on Agents types, click{' '}
              <a
                href="https://academy.geckoengage.com/en/articles/6708246-users-and-permissions"
                target="_blank"
              >
                here
              </a>
              .
            </span>
          ),
          hideWhen: () => {},
        });
      }
    } else if (GeckoPermissions.memberOf('admin')) {
      this.props.groups.map((group) => {
        options.push({
          label: `${capitalise(group.type)}`,
          value: group.id,
        });
        return group;
      });
      inviteFields.push({
        label: 'Agent Type:',
        key: 'group_id',
        type: GECKO_CONSTS.FIELD_TYPE_SELECT,
        options: options,
        description: (
          <span>
            For more information on Agents types, click{' '}
            <a
              href="https://academy.geckoengage.com/en/articles/6708246-users-and-permissions"
              target="_blank"
            >
              here
            </a>
            .
          </span>
        ),
        hideWhen: () => {},
      });
    }
    return inviteFields;
  }

  handleChange(key, value) {
    let values = this.state.values;
    values[key] = value;
    this.setState({ values });
  }

  btns = [
    {
      preset: GECKO_CONSTS.BTN_PRESET_SEND,
      handler: this.inviteAgent.bind(this),
    },
  ];

  navLinks = [
    {
      to: '/agents',
      activeClassName: 'active',
      linkText: 'Agents',
    },
    {
      to: '/teams',
      activeClassName: 'active',
      linkText: 'Teams',
    },
  ];

  render() {
    return (
      <div>
        <NavBar navLinks={this.navLinks} />
        <div className="content-margin">
          <GeckoCardForm
            name="Invite Agent"
            fields={this.inviteFields()}
            values={this.state.values}
            handler={this.handleChange.bind(this)}
            footerBtns={this.btns}
          ></GeckoCardForm>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    defaultHeaders: state.appState.defaultHeaders,
    groups: state.groups,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(Invite);
